module.exports = __webpack_public_path__ + "img/w矩形 84@3x.d2eb5503.png";